<template>
  <span
    ref="face"
    class="clock"
    v-html="clock"
  />
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      clock: this.face(),
      seconds: 0,
      showDots: true,
      timer: null,
    };
  },
  watch: {
    seconds(after, before) {
      if (after === before) {
        return;
      }

      this.resetDots();
    },
  },
  mounted() {
    this.start();
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    face(t) {
      let time = t;
      if (!time) {
        time = moment();
      }

      const dots = '<span class="clock__dots">:</span>';
      const format = 'MM/DD HH:mm';
      return time.format(format).replace(':', dots);
    },
    resetDots() {
      const className = 'clock--animated';
      const el = this.$refs.face;

      el.classList.remove(className);

      // void el.scrollWidth;

      el.classList.add(className);
    },
    start() {
      this.timer = self.setInterval(this.update, 100);
    },
    stop() {
      self.clearInterval(this.timer);
      this.timer = null;
    },
    update() {
      const now = moment();

      this.seconds = now.seconds();
      this.clock = this.face(now);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/elements/Clock.vue